export const attendancePolicyApi = {
    heading:[
        {
            head:"ID"
        },
        {
            head:"Department"
        },
        {
            head:"Deisgnation"
        },
        {
            head:"Maximum Late"
        },
        {
            head:"Maximum Early Leave"
        },
        {
            head:"Rainy Day Time Allowance"
        },
        {
            head:"Status"
        },
        {
            head:"Active From"
        },
        {
            head:"Active To"
        },
        {
            head:"Action"
        },
    ],
    data:[
       {
        id:1138,
        department:"IT",
        designation:"Software Developer",
        maxlate:"3",
        maxearlyleave:"4",
        rainydayallow:"2", 
        status:"active",
        activefrom:"3-8-23",
        activeto:"4-8-23",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        id:1138,
        department:"IT",
        designation:"Software Developer",
        maxlate:"3",
        maxearlyleave:"4",
        rainydayallow:"2", 
        status:"active",
        activefrom:"3-8-23",
        activeto:"4-8-23",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        id:1138,
        department:"IT",
        designation:"Software Developer",
        maxlate:"3",
        maxearlyleave:"4",
        rainydayallow:"2", 
        status:"active",
        activefrom:"3-8-23",
        activeto:"4-8-23",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        id:1138,
        department:"IT",
        designation:"Software Developer",
        maxlate:"3",
        maxearlyleave:"4",
        rainydayallow:"2", 
        status:"active",
        activefrom:"3-8-23",
        activeto:"4-8-23",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        id:1138,
        department:"IT",
        designation:"Software Developer",
        maxlate:"3",
        maxearlyleave:"4",
        rainydayallow:"2", 
        status:"active",
        activefrom:"3-8-23",
        activeto:"4-8-23",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        id:1138,
        department:"IT",
        designation:"Software Developer",
        maxlate:"3",
        maxearlyleave:"4",
        rainydayallow:"2", 
        status:"active",
        activefrom:"3-8-23",
        activeto:"4-8-23",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        id:1138,
        department:"IT",
        designation:"Software Developer",
        maxlate:"3",
        maxearlyleave:"4",
        rainydayallow:"2", 
        status:"active",
        activefrom:"3-8-23",
        activeto:"4-8-23",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        id:1138,
        department:"IT",
        designation:"Software Developer",
        maxlate:"3",
        maxearlyleave:"4",
        rainydayallow:"2", 
        status:"active",
        activefrom:"3-8-23",
        activeto:"4-8-23",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        id:1138,
        department:"IT",
        designation:"Software Developer",
        maxlate:"3",
        maxearlyleave:"4",
        rainydayallow:"2", 
        status:"active",
        activefrom:"3-8-23",
        activeto:"4-8-23",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        id:1138,
        department:"IT",
        designation:"Software Developer",
        maxlate:"3",
        maxearlyleave:"4",
        rainydayallow:"2", 
        status:"active",
        activefrom:"3-8-23",
        activeto:"4-8-23",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
       {
        id:1138,
        department:"IT",
        designation:"Software Developer",
        maxlate:"3",
        maxearlyleave:"4",
        rainydayallow:"2", 
        status:"active",
        activefrom:"3-8-23",
        activeto:"4-8-23",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
    },
     
       
    ]
}